// extracted by mini-css-extract-plugin
module.exports = {"overlay":"BroadcastOverlay_overlay__-tkbq","content":"BroadcastOverlay_content__RrtOW","or":"BroadcastOverlay_or__2x8uG","trigger":"BroadcastOverlay_trigger__1Z8un"};